import React from "react";
import { Card, CardBody, Col, Row, Spinner } from "reactstrap";

const Loading = ({ description }) => {
  return (
    <div className="p-4">
      <Row>
        <div className="col-md-6 offset-md-3">
          <Card>
            <CardBody>
              <div className="text-center p-4">
                <Spinner />
                <p className="py-2">{description}</p>
              </div>
            </CardBody>
          </Card>
        </div>
      </Row>
    </div>
  );
};

export default Loading;
